export default __webpack_public_path__ + "static/media/main_9.460e7e32.jpeg";